export function isAbortOrAbortCause(err: unknown): boolean {
  function isAbort(e: unknown) {
    return e instanceof DOMException && e.name === 'AbortError';
  }
  return isAbort(err) || (err instanceof Error && isAbort(err.cause));
}
